import React from 'react'
import { StyledMaterialSymbol } from './styled'
import { MaterialSymbolProps } from './types'

export const MaterialSymbol: React.FC<MaterialSymbolProps> = props => {
  return (
    <StyledMaterialSymbol name={props.name} className={props.className} style={props.style} size={props.size} onClick={props.onClick} />
  )
}
